import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { mediaUrl } from "@/lib/media";

export default function JournalArticle() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/journal/${slug}`).then((r) => setA(r.data)).catch(() => setA(false)); }, [slug]);

  if (a === false) return <PublicLayout><div className="pt-40 px-6 max-w-[1500px] mx-auto"><p className="eyebrow">Not found</p></div></PublicLayout>;
  if (!a) return <PublicLayout><div className="pt-40 px-6 max-w-[1500px] mx-auto"><p className="eyebrow">Loading…</p></div></PublicLayout>;

  // Body may be HTML (TipTap output) or legacy plain text with \n\n paragraphs.
  let html = a.body || "";
  if (!html && a.content) {
    html = (a.content || "").split("\n\n").map((p) => `<p>${p}</p>`).join("");
  }

  const seo = a.seo || {};
  return (
    <PublicLayout>
      <Seo title={seo.title || `${a.title} — Journal · Abbot Asia`} description={seo.description || a.excerpt} og_title={seo.og_title} og_description={seo.og_description} />
      <section className="pt-40 pb-12 bg-ivory">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <p className="eyebrow">{a.published_at ? new Date(a.published_at).toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" }) : ""}{a.tags?.length ? " · " + a.tags.join(" · ") : ""}</p>
          <h1 className="mt-6 font-serif text-4xl md:text-6xl text-jade font-light leading-[1.05]">{a.title}</h1>
          {a.author && <p className="mt-6 text-ink/70 text-[16px] font-light italic">{a.author}</p>}
        </div>
      </section>
      <section className="pb-12">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <img src={mediaUrl(a.hero_image)} alt={a.title} className="w-full aspect-[16/9] object-cover" />
        </div>
      </section>
      <section className="pb-32">
        <article
          className="journal-prose max-w-2xl mx-auto px-6 md:px-12 text-ink/85 text-[17px] md:text-[18px] font-light leading-[1.9]"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <div className="max-w-2xl mx-auto px-6 md:px-12 mt-10">
          <div className="divider-thin my-6" />
          <Link to="/journal" className="eyebrow">← Back to Journal</Link>
        </div>
      </section>
    </PublicLayout>
  );
}
